"use client"

import React, { FC, useEffect, useState } from 'react';
import { useAppSelector, useAppDispatch } from '@/app/lib/hooks';
import Textarea from '@/shared/Textarea';
import { getCmsEntryData } from '@/app/lib/reducers/cmsEntryDataReducer';
import { setCmsAnswer } from '@/app/lib/reducers/recruitmentReducer';
import { RootState } from '@/app/lib/store';
import { CmsEntry } from "@/data/types";
import { useTranslation } from "react-i18next";

export interface Recruitment3Props {}

const Recruitment3: FC<Recruitment3Props> = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation("guydeez");
  const auth = useAppSelector((state: RootState) => state.auth);
  const cmsData = useAppSelector((state: RootState) => state.cmsEntryData.cmsEntryData);
  const cmsAnswers = useAppSelector((state: RootState) => state.recruitment.cmsAnswers);
  const [cmsVisible, setCmsVisible] = useState(false);
  const selectedLanguage = useAppSelector(state => state.language.selectedLanguage || "en_US");

  useEffect(() => {
    dispatch(getCmsEntryData("cms-recruit0-c138-4420-8330-79ef29e19177", selectedLanguage));
  }, [dispatch, selectedLanguage]);

  useEffect(() => {
    auth?.error === "An unknown error occurred during registration" ? setCmsVisible(false) : setCmsVisible(true);
  }, [auth]);

  const handleAnswerChange = (question: string, answer: string) => {
    dispatch(setCmsAnswer(question, answer));
  };

  return (
    <>
      <div className="mt-4">
        {cmsVisible && cmsData && cmsData.map((entry: CmsEntry, index: number) => {
          const hasContent = Boolean(entry.data[0]?.content?.trim());
          return (
            <div key={`${index}_${entry.content_cms_entry__}`} style={{ marginBottom: 20 }}>
              <h3
                style={{
                  fontSize: 15,
                  fontWeight: 700,
                  color: "var(--g-burgundy)",
                  lineHeight: 1.35,
                  marginBottom: hasContent ? 4 : 8,
                }}
              >
                {entry.data[0]?.title ?? t('no_title_available')}
              </h3>
              {hasContent ? (
                <p style={{ fontSize: 12, color: "var(--g-ink-500)", lineHeight: 1.5, marginBottom: 8 }}>
                  {entry.data[0]?.content}
                </p>
              ) : null}
              <Textarea
                placeholder={t('recruitment_type_your_answer')}
                rows={3}
                value={cmsAnswers[entry.data[0]?.title ?? ""] || ''} // Handle undefined title
                onChange={(e) => handleAnswerChange(entry.data[0]?.title ?? t('no_title_available'), e.target.value)}
              />
            </div>
          );
        })}
      </div>
    </>
  );
};

export default Recruitment3;
